export default "<div>\n    {{UniteInComponent?.Identifiant}}\n</div>";